<owl-carousel-o [options]="HomeSliderConfig" class="home-slider" [ngClass]="class">

	<ng-container *ngFor="let slider of sliders">
		<ng-template carouselSlide *ngIf="!slider.VideoUrl">
			<a [href]="slider.Url?slider.Url:'javascript:void(0)'">
				<div class="home" [ngClass]="textClass"
					[ngStyle]="{'background-image': 'url('+env.mediaUrl+slider.ImageName+')'}">
				</div>
			</a>
		</ng-template>
	</ng-container>
</owl-carousel-o>